import { connect } from 'react-redux';
import MetaForm from '../components/MetaForm';
import { updateMeta } from '../actions/meta';

const mapStateToProps = (state, ownProps) => ({
  // ...ownProps,
  obj: { ...state.song.meta, id: 1 },
  changeOnly: true,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (obj) => {
    dispatch(updateMeta({ ...obj }));
  },
});

const MetaFormContainer = connect(mapStateToProps, mapDispatchToProps)(MetaForm);

export default MetaFormContainer;



// WEBPACK FOOTER //
// ./src/containers/MetaContainer.js